/**
 * Cursor-following circular fill on .ark-btn--cursor-fill (anchors and buttons).
 * Sets --ark-btn-cursor-x, --ark-btn-cursor-y (%), --ark-btn-cursor-r (px).
 *
 * Call window.arkBindCursorFillButtons(root?) after AJAX section swaps (cart drawer, etc.).
 */
(function () {
  const SELECTOR = 'a.ark-btn--cursor-fill, button.ark-btn--cursor-fill';
  const EXPANDED_CLASS = 'ark-btn--cursor-fill--expanded';
  const BOUND_ATTR = 'data-ark-cursor-fill-bound';

  /**
   * @param {HTMLElement} btn
   * @param {number} clientX
   * @param {number} clientY
   */
  function setFillCenterFromClient(btn, clientX, clientY) {
    const rect = btn.getBoundingClientRect();
    const w = rect.width || 1;
    const h = rect.height || 1;
    const pctX = ((clientX - rect.left) / w) * 100;
    const pctY = ((clientY - rect.top) / h) * 100;
    btn.style.setProperty('--ark-btn-cursor-x', pctX + '%');
    btn.style.setProperty('--ark-btn-cursor-y', pctY + '%');
  }

  /**
   * @param {HTMLElement} btn
   * @returns {number}
   */
  function hoverRadiusPx(btn) {
    const rect = btn.getBoundingClientRect();
    return Math.hypot(rect.width || 1, rect.height || 1) * 0.72 + 24;
  }

  /** @param {HTMLElement} btn */
  function resetCenter(btn) {
    btn.style.setProperty('--ark-btn-cursor-x', '50%');
    btn.style.setProperty('--ark-btn-cursor-y', '50%');
  }

  /**
   * @param {HTMLElement} btn
   * @param {PointerEvent} evt
   */
  function onPointerEnter(btn, evt) {
    btn.classList.add(EXPANDED_CLASS);

    if (evt.pointerType === 'touch') {
      resetCenter(btn);
      btn.style.setProperty('--ark-btn-cursor-r', hoverRadiusPx(btn) + 'px');
      return;
    }

    setFillCenterFromClient(btn, evt.clientX, evt.clientY);
    btn.style.setProperty('--ark-btn-cursor-r', hoverRadiusPx(btn) + 'px');
  }

  /**
   * @param {HTMLElement} btn
   * @param {PointerEvent} evt
   */
  function onPointerMove(btn, evt) {
    if (evt.pointerType === 'touch') return;
    setFillCenterFromClient(btn, evt.clientX, evt.clientY);
  }

  /** @param {HTMLElement} btn */
  function onPointerLeave(btn) {
    btn.classList.remove(EXPANDED_CLASS);
    btn.style.setProperty('--ark-btn-cursor-r', '0px');
  }

  /** @param {HTMLElement} btn */
  function bind(btn) {
    if (btn.getAttribute(BOUND_ATTR) === 'true') return;

    btn.setAttribute(BOUND_ATTR, 'true');
    resetCenter(btn);
    btn.style.setProperty('--ark-btn-cursor-r', '0px');

    btn.addEventListener('pointerenter', function (evt) {
      onPointerEnter(btn, /** @type {PointerEvent} */ (evt));
    });
    btn.addEventListener('pointermove', function (evt) {
      onPointerMove(btn, /** @type {PointerEvent} */ (evt));
    });
    btn.addEventListener('pointerleave', function () {
      onPointerLeave(btn);
    });
  }

  /**
   * @param {ParentNode} [root]
   */
  function bindAll(root) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(function (node) {
      bind(/** @type {HTMLElement} */ (node));
    });
  }

  window.arkBindCursorFillButtons = bindAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll(document);
    });
  } else {
    bindAll(document);
  }
})();
